import { useDistributionDeliveryEstimate } from "~/hooks/useDeliveryEstimates/useDistributionDeliveryEstimate";
import { useDraftDbsBaskets } from "~/pages/discovery/v2/distribution/useDraftDbsBaskets";
import { useStorefrontBuyerPostcode } from "../lib/useStorefrontBuyerPostcode";
import { useRemoteFeatureFlags } from "~/hooks/useRemoteFeatureFlags";
import { useDiscoverySupplierList } from "~/hooks/api/v2/discovery/useDiscoverySupplierList";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";

export const useCanDisplayStorefrontConsolidatedBasketBanner = (
  supplier: Pick<SupplierGetResponseType, "id" | "Business" | "CustomerZones">,
) => {
  const { totalItemCount } = useDraftDbsBaskets();
  const sdConsolidatedCheckoutEnabled = useRemoteFeatureFlags().isActive(
    "sdConsolidatedCheckout",
  );

  const { buyerPostcode } = useStorefrontBuyerPostcode();
  const { nextDeliveryDate: nextDistributionDeliveryDate } =
    useDistributionDeliveryEstimate({
      supplierId: supplier.id,
      buyerPostcode: buyerPostcode,
      productIds: [],
    });

  const supplierListQuery = useDiscoverySupplierList({
    limit: 1,
    search: supplier.Business.name,
    query: [
      {
        type: "deliveredBySellar",
        value: true,
        modifier: "EQUALS",
      },
    ],
    retailerPostcode: buyerPostcode,
  });

  const canSupplierBeDeliveredToBySellar =
    (supplierListQuery.data?.pages.flat() ?? []).length > 0;

  const hasNextDistributionDeliveryDate = !!nextDistributionDeliveryDate;
  const hasSDCustomerZone = supplier.CustomerZones.some(
    (zone) => zone.systemDefinedType === "sellarDistribution",
  );

  return (
    totalItemCount > 0 &&
    hasNextDistributionDeliveryDate &&
    hasSDCustomerZone &&
    sdConsolidatedCheckoutEnabled &&
    canSupplierBeDeliveredToBySellar
  );
};
